export default [
  {
    check: false,
    title: "굴착작업(굴착면의 높이가 2m 이상)",
    typeLists: [
      {
        headerTitle: "사전조사 내용",
        data: [
          {
            content: ["가", "형상·지질 및 지층의 상태"],
            isChecked: "",
          },
          {
            content: ["나", "균열·함수(含水)·용수 및 동결의 유무 또는 상태"],
            isChecked: "",
          },
          {
            content: ["다", "매설물 등의 유무 또는 상태"],
            isChecked: "",
          },
          {
            content: ["라", "지반의 지하수위 상태"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "굴착방법 및 순서, 토사 반출 방법"],
            isChecked: "",
          },
          {
            content: ["나", "필요한 인원 및 장비 사용계획"],
            isChecked: "",
          },
          {
            content: ["다", "매설물 등에 대한 이설·보호대책"],
            isChecked: "",
          },
          {
            content: ["라", "사업장 내 연락방법 및 신호방법"],
            isChecked: "",
          },
          {
            content: ["마", "흙막이 지보공 설치방법 및 계측계획"],
            isChecked: "",
          },
          {
            content: ["바", "작업지휘자의 배치계획"],
            isChecked: "",
          },
          {
            content: ["사", "그 밖에 안전·보건에 관련된 사항"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "터널굴착작업",
    typeLists: [
      {
        headerTitle: "사전조사 내용",
        data: [
          {
            content: ["가", "보링(boring) 등 적절한 방법으로 낙반·출수(出水) 및 가스폭발 등으로 인한 근로자의 위험을 방지하기 위하여 미리 지형·지질 및 지층상태를 조사"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "굴착의 방법"],
            isChecked: "",
          },
          {
            content: ["나", "터널지보공 및 복공(覆工)의 시공방법과 용수(湧水)의 처리방법"],
            isChecked: "",
          },
          {
            content: ["다", "환기 또는 조명시설을 설치할 때에는 그 방법"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "교량작업",
    typeLists: [
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "작업 방법 및 순서"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "채석작업",
    typeLists: [
      {
        headerTitle: "사전조사 내용",
        data: [
          {
            content: ["가", "지반의 붕괴·굴착기계의 굴러 떨어짐 등에 의한 근로자에게 발생할 위험을 방지하기 위한 해당 작업장의 지형·지질 및 지층의 상태"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "노천굴착과 갱내굴착의 구별 및 채석방법"],
            isChecked: "",
          },
          {
            content: ["나", "굴착면의 높이와 기울기"],
            isChecked: "",
          },
          {
            content: ["다", "굴착면 소단(小段: 비탈면의 경사를 완화시키기 위해 중간에 좁은 폭으로 설치하는 평탄한 부분)의 위치와 넓이"],
            isChecked: "",
          },
          {
            content: ["라", "갱내에서의 낙반 및 붕괴방지 방법"],
            isChecked: "",
          },
          {
            content: ["마", "발파방법"],
            isChecked: "",
          },
          {
            content: ["바", "암석의 분할방법"],
            isChecked: "",
          },
          {
            content: ["사", "암석의 가공장소"],
            isChecked: "",
          },
          {
            content: ["아", '사용하는 굴착기계·분할기계·적재기계 또는 운반기계(이하 "굴착기계등"이라 한다)의 종류 및 성능'],
            isChecked: "",
          },
          {
            content: ["자", "토석 또는 암석의 적재 및 운반방법과 운반경로"],
            isChecked: "",
          },
          {
            content: ["차", "표토 또는 용수(湧水)의 처리방법"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "건물 등의 해체작업",
    typeLists: [
      {
        headerTitle: "사전조사 내용",
        data: [
          {
            content: ["가", "해체건물 등의 구조, 주변 상황 등"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "해체의 방법 및 해체 순서도면"],
            isChecked: "",
          },
          {
            content: ["나", "가설설비·방호설비·환기설비 및 살수·방화설비 등의 방법"],
            isChecked: "",
          },
          {
            content: ["다", "사업장 내 연락방법"],
            isChecked: "",
          },
          {
            content: ["라", "해체물의 처분계획"],
            isChecked: "",
          },
          {
            content: ["마", "해체작업용 기계·기구 등의 작업계획서"],
            isChecked: "",
          },
          {
            content: ["바", "해체작업용 화약류 등의 사용계획서"],
            isChecked: "",
          },
          {
            content: ["사", "그 밖에 안전·보건에 관련된 사항"],
            isChecked: "",
          },
        ],
      },
    ],
  },
];
